import { createContext } from 'react';

/** @internal */
export const AppShellContext = createContext<{
  sideNavIsOpen: boolean;
  toggleSideNav: (isOpen?: boolean) => void;
} | null>(null);
